module.exports = __webpack_public_path__ + "img/fair-meter.74e8dec0.svg";